import {ISVG} from "../../common/Logo/Logo";

export interface ICircle2Props extends Pick<ISVG, "fill"> {}

export const Circle2 = ({ fill }: ICircle2Props) => {
    const _fill = fill ?? "#F3F2E9";

    return (
        <svg
            width="108"
            height="107"
            viewBox="0 0 108 107"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M51.7104 0.0869057C67.012 -0.507263 83.1629 1.7688 94.1354 12.4214C105.217 23.1801 108.136 39.3077 107.995 54.7308C107.856 69.9877 104.59 85.9042 93.3678 96.2747C82.4486 106.365 66.5665 107.695 51.7104 106.745C37.951 105.865 24.7757 101.037 15.0729 91.2685C5.41657 81.5462 0.520153 68.407 0.0489209 54.7308C-0.440924 40.5143 2.68041 25.9425 12.4654 15.5927C22.5001 4.97869 37.0938 0.654475 51.7104 0.0869057Z"
                fill={_fill}
            />
        </svg>
    );
};
